import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as firebaseCourses from '../../services/firebaseCourses';
import { isTextLesson } from '../../utils/lessonUtils';

function flatten(curriculum) {
  return (curriculum || []).flatMap((s) => s?.lessons || []);
}

export default function CourseStart() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    firebaseCourses
      .getCourse(courseId)
      .then((detail) => {
        if (isMounted) setCourse(detail || null);
      })
      .catch(() => {
        if (isMounted) setCourse(null);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [courseId]);

  const lessons = useMemo(() => flatten(course?.curriculum), [course?.curriculum]);

  useEffect(() => {
    if (loading) return;
    if (!course || lessons.length === 0) {
      navigate('/', { replace: true });
      return;
    }

    const firstText = lessons.find((l) => isTextLesson(l));
    const first = firstText || lessons[0];
    if (isTextLesson(first)) {
      navigate(`/course/${courseId}/read/${first.id}`, { replace: true });
    } else {
      navigate(`/course/${courseId}/learn/${first.id}`, { replace: true });
    }
  }, [loading, course, lessons, courseId, navigate]);

  return null;
}

